var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apresentacao-fotos-lote"},[(_vm.imagem)?_c('img',{ref:"imagem",attrs:{"src":_vm.imagem}}):_c('div',[_vm._v("Buscando fotos do lote...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }